import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HeaderRepository } from '@ui/features/headers/infrastructure/header.repository';

@Injectable()
export class StandardHeadersInterceptor implements HttpInterceptor {
    private headerRepository: HeaderRepository = new HeaderRepository();

    public intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        const requestWithHeaders: HttpRequest<unknown> = request.clone({
            setHeaders: this.headerRepository.buildHeaders(),
        });

        return next.handle(requestWithHeaders);
    }
}
